module.exports = __webpack_public_path__ + "img/bin.51d7d896.png";